import React, { useState } from "react";
import "./QuestionInput.scss";
import { db } from "../services/firebase";
import { isEmpty } from "ramda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const QuestionInput = ({ setModalOpen }) => {
  const [countCharsLeft, setCharsLeft] = useState(150);
  const [questionText, setQuestionText] = useState("");
  const [questionInputOpen, setQuestionInputOpen] = useState(false);

  const textareaOnChange = (value) => {
    // console.log(value.length);
    if (value.length <= 150) {
      setQuestionText(value);
      setCharsLeft(countCharsLeft - 1);
      setCharsLeft(150 - value.length);
    }
  };

  const submitNewQuestion = () => {
    db.ref("question-list")
      .push({
        approved: 0,
        text: questionText,
        nLikes: 0,
        nDislikes: 0,
        ratio: 0,
        timeStamp: Date.now(),
      })
      .then(() => {
        setModalOpen(true);
        setCharsLeft(150);
        setQuestionText("");
      });
  };

  return (
    <div className="QuestionInput">
      <div className="label-icon-container">
        <div className="label-icon" onClick={() => setQuestionInputOpen(!questionInputOpen)}>
          <label>Füge eine neue Frage hinzu</label>
          <span className="icon">
            <FontAwesomeIcon icon={questionInputOpen ? ["fas", "chevron-up"] : ["fas", "chevron-down"]} />
          </span>
        </div>
      </div>
      {questionInputOpen && (
        <div className="field">
          <div className="control">
            <textarea
              className="textarea is-primary"
              placeholder="Frage hier reinschreiben..."
              typeof="text"
              maxLength="150"
              value={questionText}
              onChange={(event) => textareaOnChange(event.target.value)}
            ></textarea>
            <div className="label-button-container">
              <p className="CharsLeftLabel">Verbleibende Zeichen {countCharsLeft}/150</p>
              <button className="button is-info" onClick={submitNewQuestion} disabled={isEmpty(questionText)}>
                Abschicken
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
